import moment from "moment";
import type { IOfferHierarchy } from "../../../../store/slices/offering/types";

/**
 * Получение children иерархии предложения, содержащих только вхождения в заданный диапазон дат
 * Пример использования: получить версии для заданного временного диапазона
 */

export const getDatesSatisfyingHierarchyChildren = (params: {
  children: Partial<IOfferHierarchy<string>>[] | undefined;
  fromDate: string | undefined;
  toDate: string | undefined;
}): Partial<IOfferHierarchy<string>>[] | undefined => {
  const { children, fromDate, toDate } = params;
  if (!fromDate || !toDate) {
    return children;
  }
  const filteredChildren: Partial<IOfferHierarchy<string>>[] | undefined = children?.filter(
    (child) => {
      // Попадание child.fromDate в заданный диапазон
      const isSatisfyingFromDate = moment(child.fromDate).isBetween(fromDate, toDate, "day", "[]");
      // Попадание child.toDate в заданный диапазон
      const isSatisfyingToDate = moment(child.toDate).isBetween(fromDate, toDate, "day", "[]");
      // Попадание заданного fromDate в диапазон дат версии
      const isSatisfyingVersionFromDate = moment(fromDate).isBetween(
        child.fromDate,
        child.toDate,
        "day",
        "[]"
      );
      // Попадание заданного toDate в диапазон дат версии
      const isSatisfyingVersionToDate = moment(toDate).isBetween(
        child.fromDate,
        child.toDate,
        "day",
        "[]"
      );
      return (
        isSatisfyingFromDate ||
        isSatisfyingToDate ||
        isSatisfyingVersionFromDate ||
        isSatisfyingVersionToDate
      );
    }
  );
  return filteredChildren;
};
